import { render } from "./Main.vue?vue&type=template&id=2446ea34"
const script = {}
script.render = render

export default script